export function getLocalData (key = '') {
  const localData = JSON.parse(localStorage.getItem(key))

  if (!localData) {
    return null
  }

  return localData
}

export function setLocalData (key = '', data = {}) {
  if (!key || !data) {
    return false
  }

  localStorage.setItem(key, JSON.stringify(data))

  return true
}

export function clearLocalData (key = '') {
  if (!key) {
    return false
  }

  localStorage.removeItem(key)

  return true
}

